import { writable } from 'svelte/store';

interface LoadingState {
	hero: boolean;
	features: boolean;
	translations: boolean;
	fonts: boolean;
}

// Create loading state store
export const loading = writable<LoadingState>({
	hero: true,
	features: true,
	translations: true,
	fonts: true
});

// Helper functions to update loading states
export const setLoading = (key: keyof LoadingState, value: boolean) => {
	loading.update(state => ({
		...state,
		[key]: value
	}));
};

export const setAllLoaded = () => {
	loading.set({
		hero: false,
		features: false,
		translations: false,
		fonts: false
	});
};

// Check if critical content is loaded (hero + translations)
export const isCriticalContentLoaded = (state: LoadingState): boolean => {
	return !state.hero && !state.translations && !state.fonts;
};